import React from "react";

export const Landing = () => {
	return <div>Hi this is iframe tab</div>;
};
